import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ProjectDuplicateCustomPartOfferPage } from '@/areas/offers/CustomPartOfferForm/pages/ProjectDuplicateCustomPartOfferPage';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ sourcingLineItemId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const sourcingLineItemId = Route.useSearch({ select: (search) => search.sourcingLineItemId });
    return (
        <ProjectDuplicateCustomPartOfferPage
            projectId={pathParams.projectId}
            offerId={pathParams.offerId}
            sourcingLineItemId={sourcingLineItemId}
        />
    );
}
